import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupSvg',
  props: {
  width: {
    type: [String, Number],
    default: 17,
  },
  height: {
    type: [String, Number],
    default: 15,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps(_ctx.$attrs, {
    width: __props.width,
    height: __props.height,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), [
    _createElementVNode("path", {
      d: "M6.3125 14.2698C6.3125 14.2698 5.125 14.2698 5.125 13.0806C5.125 11.8915 6.3125 8.32404 11.0625 8.32404C15.8125 8.32404 17 11.8915 17 13.0806C17 14.2698 15.8125 14.2698 15.8125 14.2698H6.3125ZM11.0625 7.13489C12.0073 7.13489 12.9135 6.75904 13.5816 6.09001C14.2497 5.42098 14.625 4.51359 14.625 3.56744C14.625 2.6213 14.2497 1.71391 13.5816 1.04488C12.9135 0.375855 12.0073 0 11.0625 0C10.1177 0 9.21153 0.375855 8.54343 1.04488C7.87533 1.71391 7.5 2.6213 7.5 3.56744C7.5 4.51359 7.87533 5.42098 8.54343 6.09001C9.21153 6.75904 10.1177 7.13489 11.0625 7.13489Z",
      fill: __props.fill
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.51211 13.4625C4.38387 13.1921 4.31992 12.8956 4.32526 12.5962C4.32526 11.4225 4.91349 10.214 6 9.37378C5.45769 9.20645 4.89269 9.12462 4.32526 9.13123C0.865052 9.13123 0 11.73 0 12.5962C0 13.4625 0.865052 13.4625 0.865052 13.4625H4.51211Z",
      fill: __props.fill
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M4.6875 6.47712C5.30081 6.47712 5.88901 6.23315 6.32268 5.79887C6.75636 5.36459 7 4.77558 7 4.16141C7 3.54725 6.75636 2.95824 6.32268 2.52396C5.88901 2.08968 5.30081 1.8457 4.6875 1.8457C4.07419 1.8457 3.48599 2.08968 3.05232 2.52396C2.61864 2.95824 2.375 3.54725 2.375 4.16141C2.375 4.77558 2.61864 5.36459 3.05232 5.79887C3.48599 6.23315 4.07419 6.47712 4.6875 6.47712Z",
      fill: __props.fill
    }, null, 8, _hoisted_4)
  ], 16, _hoisted_1))
}
}

})